import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography} from "@mui/material";
import {IconChevronDown} from "@tabler/icons-react";
import {UI, rgba} from "../../uiTokens";

// Generic edit-menu control styling now lives in editMenuStyles; re-exported here
// so the route tabs keep importing from one place.
export {
    fieldSx,
    checkboxSx,
    controlLabelSx,
    sectionLabelSx,
    iconBtnSx,
    iconBtnDangerSx,
} from "../editMenuStyles";

/**
 * A collapsible card for one route. The accent border / dot signal whether the
 * route currently points somewhere.
 */
export const RouteSection = ({title, description, connected, connectedLabel, defaultExpanded, children}) => (
    <Box
        sx={{
            borderRadius: "10px",
            overflow: "hidden",
            border: `1px solid ${connected ? rgba(UI.accent, 0.35) : rgba(UI.ink, 0.1)}`,
            backgroundColor: connected ? rgba(UI.accent, 0.04) : UI.surface,
        }}
    >
        <Accordion
            disableGutters
            elevation={0}
            defaultExpanded={defaultExpanded}
            sx={{
                backgroundColor: "transparent",
                "&:before": {display: "none"},
                "&.Mui-expanded": {margin: 0},
            }}
        >
            <AccordionSummary
                expandIcon={<IconChevronDown size={16} color={UI.muted}/>}
                sx={{
                    px: 1.25,
                    minHeight: 0,
                    "& .MuiAccordionSummary-content": {my: 1, minWidth: 0},
                }}
            >
                <Stack sx={{width: "100%", minWidth: 0}}>
                    <Stack direction="row" alignItems="center" gap={0.75} sx={{minWidth: 0}}>
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 7,
                                height: 7,
                                borderRadius: "50%",
                                backgroundColor: connected ? UI.accent : rgba(UI.ink, 0.2),
                            }}
                        />
                        <Typography sx={{fontWeight: 700, fontSize: 12.5, textTransform: "capitalize", color: UI.ink}}>
                            {title}
                        </Typography>
                        <Box sx={{flex: 1}}/>
                        {connected && connectedLabel && (
                            <Typography noWrap sx={{fontSize: 11, fontWeight: 600, color: UI.accent, maxWidth: 120}}>
                                → {connectedLabel}
                            </Typography>
                        )}
                    </Stack>
                    {description && (
                        <Typography sx={{mt: 0.4, fontSize: 11, color: UI.muted, lineHeight: 1.35}}>
                            {description}
                        </Typography>
                    )}
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{px: 1.25, pt: 0, pb: 1.25}}>
                <Stack gap={1.25} sx={{pt: 0.5, borderTop: `1px solid ${rgba(UI.ink, 0.06)}`}}>
                    {children}
                </Stack>
            </AccordionDetails>
        </Accordion>
    </Box>
);
